import { render, staticRenderFns } from "./caiJing.vue?vue&type=template&id=419164a4&scoped=true&"
import script from "./caiJing.vue?vue&type=script&lang=js&"
export * from "./caiJing.vue?vue&type=script&lang=js&"
import style0 from "./caiJing.vue?vue&type=style&index=0&id=419164a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419164a4",
  null
  
)

export default component.exports